'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _commonjsHelpers = require('./_commonjsHelpers.js');
var index = require('../node_modules/@gatsbyjs/reach-router/es/index.js');

var _reachRouter = /*@__PURE__*/_commonjsHelpers.getAugmentedNamespace(index);

exports['default'] = _reachRouter;
//# sourceMappingURL=index3.js_commonjs-proxy.map
